import React from "react";
import { Spin } from "antd";
import { LoadingOutlined } from "@ant-design/icons";

const LoadingOverlay = ({ text = "Loading..." }) => (
  <div
    style={{
      position: "fixed",
      inset: 0,
      backgroundColor: "rgba(255, 255, 255, 0.6)",
      zIndex: 9998,
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "center",
      gap: "12px",
      backdropFilter: "blur(2px)",
    }}
  >
    <Spin size="large" indicator={<LoadingOutlined style={{ fontSize: 40, color: "#1a2e5a" }} spin />} />
    <span style={{ color: "#1a2e5a", fontSize: "14px", fontWeight: 500 }}>{text}</span>
  </div>
);

export default LoadingOverlay;
